import React from 'react';
import { WHERE, IMAGES } from '../data/mock';
import Reveal from './Reveal';
import { MapPin } from 'lucide-react';

const LocationSection = () => {
  return (
    <section id="where" className="relative py-24 md:py-40 px-6 md:px-10 overflow-hidden">
      <div
        role="img"
        aria-label="The Cottage — COLAB Theatre's Tudor doorway at 169a Borough High Street, London Bridge. Home to one of London's most scary immersive Halloween experiences."
        className="absolute inset-0 bg-cover bg-center opacity-40"
        style={{ backgroundImage: `url(${IMAGES.doorway})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0705] via-[#0a0705]/70 to-[#0a0705]" />

      <div className="relative max-w-4xl mx-auto text-center">
        <Reveal>
          <h2 className="font-display text-6xl md:text-7xl text-[#e8dcc0] lowercase">
            {WHERE.heading}
          </h2>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-8 divider-ornament max-w-md mx-auto">
            <MapPin className="w-3.5 h-3.5 text-[#c8935a]/70" />
          </div>
        </Reveal>

        <Reveal delay={200}>
          <p className="mt-10 font-fell italic text-2xl md:text-3xl text-[#d9c8a3]">
            {WHERE.venue}
          </p>
        </Reveal>

        <Reveal delay={300}>
          <p className="mt-4 font-display text-sm md:text-base tracking-[0.35em] uppercase text-[#c8935a]">
            {WHERE.address}
          </p>
          <p className="mt-2 font-fell italic text-sm text-[#8b7355]">
            {WHERE.addressLine2}
          </p>
        </Reveal>

        <Reveal delay={400}>
          <p className="mt-10 font-fell text-lg md:text-xl text-[#a89880] leading-[1.85] max-w-2xl mx-auto">
            {WHERE.detail}
          </p>
        </Reveal>

        <Reveal delay={500}>
          <p className="mt-12 font-fell-sc text-xs md:text-sm tracking-[0.35em] text-[#c8935a] uppercase">
            {WHERE.format}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default LocationSection;
